import type { Translations } from '../types.js';

export const ru: Translations = {
  nav: {
    overview: 'Панель управления',
    users: 'Пользователи',
    devices: 'Устройства',
    subscriptions: 'Подписки',
    entitlements: 'Права доступа',
    features: 'Функции',
    config: 'Настройки',
    commands: 'Команды',
    snapshots: 'Диагностика',
    audit: 'Аудит',
    system: 'Состояние системы',
    consoleTag: 'Консоль v1.0',
    signOut: 'Выйти',
    expandSidebar: 'Развернуть меню',
    collapseSidebar: 'Свернуть меню',
  },
  topbar: {
    admin: 'Админ',
    searchPlaceholder: 'Поиск пользователей, устройств, команд...',
    searchShortcut: '⌘K',
    lightMode: 'Светлая тема',
    darkMode: 'Тёмная тема',
    systemTheme: 'Системная тема',
    notifications: 'Уведомления',
    profile: 'Профиль',
    language: 'Язык',
  },
  login: {
    title: 'Панель управления Hisob',
    subtitle: 'Конфиденциальное администрирование и телеметрия мобильных устройств',
    emailLabel: 'Email администратора',
    emailPlaceholder: 'например, admin@hisob.uz',
    secretLabel: 'Секретный ключ доступа',
    secretPlaceholder: '••••••••••••••••',
    submitButton: 'Войти в консоль',
    signingIn: 'Вход...',
    errorRequired: 'Пожалуйста, введите email администратора и секретный ключ',
    errorInvalid: 'Неверные данные администратора',
    devSwitcherTitle: 'Быстрый выбор роли (Разработка)',
  },
  common: {
    search: 'Поиск',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    restore: 'Восстановить',
    filter: 'Фильтр',
    refresh: 'Обновить',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    loading: 'Загрузка...',
    actions: 'Действия',
    status: 'Статус',
    success: 'Успешно',
    error: 'Ошибка',
    view: 'Просмотр',
    edit: 'Редактировать',
    all: 'Все',
    active: 'Активный',
    inactive: 'Неактивный',
    pending: 'В ожидании',
    failed: 'Неудачно',
    revoked: 'Отозван',
    copied: 'Скопировано',
    copy: 'Копировать',
    back: 'Назад',
    authenticating: 'Проверка сессии администратора...',
    yes: 'Да',
    no: 'Нет',
    resetFilters: 'Сбросить фильтры',
    firstPage: 'Первая страница',
    nextPage: 'Следующая страница',
    details: 'Подробнее',
    viewAll: 'Посмотреть все',
  },
  statusPages: {
    notFoundTitle: '404 — Страница не найдена',
    notFoundDesc: 'Запрошенный маршрут или административный ресурс не существует или был перемещён.',
    returnToDashboard: 'Вернуться в панель управления',
    forbiddenTitle: '403 — Действие запрещено',
    forbiddenDesc: 'Ваша текущая роль администратора не имеет достаточных прав доступа (RBAC).',
    returnToSafety: 'Вернуться в безопасность',
  },
  searchModal: {
    title: 'Глобальный операционный поиск',
    placeholder: 'Поиск по ID пользователя, ID устройства, ID команды, версии...',
    noResults: 'Записей не найдено по запросу: ',
    typeMinChars: 'Введите минимум 2 символа для поиска среди пользователей, устройств и команд.',
    pressEsc: 'Нажмите ESC для закрытия',
    tip: 'Подсказка: Вы можете сразу перейти к найденным ресурсам',
    users: 'Пользователи',
    devices: 'Устройства',
    commands: 'Команды',
    snapshots: 'Диагностические снимки',
    subscriptions: 'Подписки',
  },
  dashboard: {
    title: 'Панель управления',
    totalUsers: 'Всего пользователей',
    activeDevices: 'Активные устройства',
    onlineDevices: 'Устройства онлайн',
    premiumUsers: 'Премиум пользователи',
    subscriptions: 'Подписки',
    pendingCommands: 'Ожидающие команды',
    activeSnapshots: 'Активная диагностика',
    featureFlagsOn: 'Включенные фичи',
    systemHealth: 'Состояние системы',
    recentActivity: 'Последняя активность',
    failedToLoad: 'Не удалось загрузить показатели панели',
    bannerTitle: 'Операционный статус системы',
    bannerDesc: 'Edge-сеть Cloudflare работает штатно. Телеметрия устройств передаётся в реальном времени.',
    dispatchCommand: 'Отправить команду',
    inspectFleet: 'Обзор устройств',
    infraHealthTitle: 'Состояние инфраструктуры Cloudflare Edge',
    checkedAgo: 'Проверено {time}',
    chartActiveDevices: 'Ежедневно активные устройства (7 дней)',
    chartPlatforms: 'Распределение платформ',
    recentFleetCommands: 'Последние команды устройствам',
    recentAuditEvents: 'Последние события аудита',
    deviceLabel: 'Устройство',
    targetLabel: 'Объект',
  },
  users: {
    title: 'Управление пользователями',
    description: 'Учётные записи, статус привязки Telegram и мониторинг активности',
    searchPlaceholder: 'User ID, Номер телефона или Chat ID...',
    allTelegram: 'Все статусы Telegram',
    linkedOnly: 'Только привязанные',
    unlinkedOnly: 'Не привязанные',
    allStatuses: 'Все статусы',
    activeStatus: 'Активен',
    suspendedStatus: 'Приостановлен',
    deletedStatus: 'Удалён',
    tableUserId: 'User ID',
    tablePhone: 'Номер телефона',
    tableTelegram: 'Статус Telegram',
    tableLastLogin: 'Последний вход / Проверка',
    tableStatus: 'Статус',
    tableRegistered: 'Зарегистрирован',
    tableActions: 'Действия',
    noPhone: 'Не указан',
    noLoginRecorded: 'Вход не зафиксирован',
    emptyTitle: 'Пользователи не найдены',
    emptyDesc: 'Нет пользователей, соответствующих заданным критериям.',
    totalCount: 'Всего: {count} пользователей',
    loadError: 'Не удалось загрузить список пользователей',
  },
  userDetail: {
    backButton: 'Назад к пользователям',
    title: 'Информация о пользователе',
    privacyNoticeTitle: 'Примечание о безопасности и конфиденциальности:',
    privacyNoticeDesc: 'В соответствии с архитектурой Hisob, финансовые данные (балансы, транзакции, карты) никогда не сохраняются на сервере и хранятся исключительно на устройствах пользователя. Административная панель управляет только ключами устройств, подписками и запросами диагностики.',
    accountOverview: 'Обзор аккаунта',
    phoneNumber: 'Номер телефона',
    telegramChatId: 'Telegram Chat ID',
    registeredAt: 'Дата регистрации',
    lastActive: 'Последняя активность',
    accountStatus: 'Статус аккаунта',
    registeredDevices: 'Привязанные устройства',
    noDevices: 'У данного пользователя нет привязанных устройств.',
    entitlementsTitle: 'Права и подписки',
    noEntitlements: 'Активных подписок или прав не обнаружено.',
    notFoundTitle: 'Пользователь не найден',
  },
  devices: {
    title: 'Парк мобильных устройств',
    description: 'Зарегистрированные клиенты iOS и Android, статус токенов безопасности и телеметрия',
    searchPlaceholder: 'Поиск по ID устройства, ID пользователя, модели...',
    allPlatforms: 'Все платформы',
    tableDeviceId: 'ID устройства',
    tableUserId: 'User ID',
    tableModelPlatform: 'Модель и платформа',
    tableAppVersion: 'Версия приложения',
    tableStatus: 'Статус',
    tableLastSeen: 'Был в сети',
    tableActions: 'Действия',
    online: 'Онлайн',
    offline: 'Офлайн',
    revoked: 'Отозван',
    revokeButton: 'Отозвать',
    revokeModalTitle: 'Отозвать доступ устройства',
    revokeModalMessage: 'Вы уверены, что хотите отозвать доступ устройства "{id}"? Все активные токены будут аннулированы, и устройство будет отключено от сервера.',
    revokeConfirmText: 'Отозвать навсегда',
    revokeSuccessToast: 'Доступ устройства успешно отозван',
    emptyTitle: 'Устройства не найдены',
    emptyDesc: 'Нет устройств, соответствующих заданным условиям.',
    totalCount: 'Показано {count} устройств',
    loadError: 'Не удалось загрузить список устройств',
  },
  deviceDetail: {
    backButton: 'Назад к устройствам',
    title: 'Информация об устройстве',
    hardwareSpecs: 'Аппаратные характеристики',
    model: 'Модель',
    platform: 'Платформа',
    osVersion: 'Версия ОС',
    appVersion: 'Версия приложения',
    registeredAt: 'Зарегистрировано',
    lastSeen: 'Последняя связь',
    securityStatus: 'Статус безопасности',
    deviceTokenStatus: 'Токен устройства',
    userId: 'ID пользователя',
    quickCommands: 'Быстрые команды',
    dispatchCommandBtn: 'Отправить команду',
    commandsHistory: 'История команд',
    noCommands: 'Для этого устройства нет команд.',
    modalTitle: 'Создать команду для устройства',
    commandTypeLabel: 'Тип команды',
    commandReasonLabel: 'Причина / Цель',
    commandReasonPlaceholder: 'например, для проверки ошибки пользователя',
    commandTtlLabel: 'Срок действия (в часах)',
    submitCommand: 'Поставить команду в очередь',
    revokeConfirmTitle: 'Отозвать доступ устройства',
  },
  subscriptions: {
    title: 'Реестр подписок магазинов',
    description: 'Покупки через App Store, Google Play и RevenueCat, проверенные на Edge',
    searchPlaceholder: 'Поиск по пользователю, внешнему ID или продукту...',
    tableId: 'ID',
    tableUserId: 'User ID',
    tableStore: 'Магазин',
    tableProduct: 'ID продукта',
    tableStatus: 'Статус',
    tableExpiresAt: 'Истекает',
    tableCreatedAt: 'Создано',
    emptyTitle: 'Подписки не найдены',
    emptyDesc: 'Нет подписок, соответствующих условиям поиска.',
    loadError: 'Не удалось загрузить подписки',
  },
  entitlements: {
    title: 'Подтверждённые права пользователей',
    description: 'Функциональные привилегии, выданные на основе чеков или административно',
    searchPlaceholder: 'Поиск по User ID или ключу доступа...',
    tableUserId: 'User ID',
    tableEntitlement: 'Ключ права',
    tableStatus: 'Статус',
    tableGrantedBy: 'Источник',
    tableExpiresAt: 'Истекает',
    emptyTitle: 'Права не найдены',
    emptyDesc: 'Никаких прав доступа не найдено.',
    loadError: 'Не удалось загрузить права пользователей',
  },
  features: {
    title: 'Управление фича-флагами (Feature Flags)',
    description: 'Безопасное включение и постепенное развертывание функций мобильного приложения',
    searchPlaceholder: 'Поиск по ключу флага...',
    newFlagBtn: 'Новый флаг',
    tableKey: 'Ключ флага',
    tableStatus: 'Статус',
    tableRollout: 'Охват %',
    tableMinVersion: 'Мин. версия',
    tablePlatform: 'Платформа',
    tablePremiumOnly: 'Только Премиум',
    tableActions: 'Действия',
    freeTier: 'Бесплатный тариф',
    editModalTitle: 'Редактировать флаг: {key}',
    createModalTitle: 'Создать новый флаг',
    flagKeyLabel: 'Ключ флага (например: telegram_otp_auth, new_dashboard)',
    flagKeyPlaceholder: 'например: premium.ai_insights',
    enabledLabel: 'Включен',
    enabledHelp: 'Мгновенно переключает функцию для подходящих сегментов устройств.',
    rolloutLabel: 'Процент раскатки (%)',
    rolloutHelp: 'Сервер применяет стабильный SHA-256 хеш по Device ID. Без мерцания между сессиями.',
    platformLabel: 'Платформа',
    platformAll: 'Все платформы',
    platformIos: 'Только iOS',
    platformAndroid: 'Только Android',
    platformWeb: 'Только Web',
    minVersionLabel: 'Минимальная версия приложения',
    minVersionPlaceholder: 'например, 1.2.0 (необязательно)',
    premiumOnlyLabel: 'Только для премиум пользователей',
    premiumOnlyHelp: 'Только устройства с активной подпиской получат flag = true.',
    configJsonLabel: 'Дополнительный JSON конфиг',
    jsonMalformedError: 'Неверный формат JSON конфигурации',
    saveBtn: 'Сохранить изменения',
    createBtn: 'Создать флаг',
    saveSuccess: 'Флаг успешно обновлен',
    createSuccess: 'Флаг успешно создан',
    emptyTitle: 'Флаги не найдены',
    emptyDesc: 'В системе пока нет созданных фича-флагов.',
    loadError: 'Не удалось загрузить список флагов',
  },
  config: {
    title: 'Удалённая конфигурация (Remote Config)',
    description: 'Глобальные параметры приложения, принудительное обновление и режим техработ',
    minVersionTitle: 'Минимально поддерживаемая версия',
    minVersionDesc: 'Клиенты с версией ниже этой будут обязаны обновиться.',
    latestVersionTitle: 'Текущая актуальная версия',
    latestVersionDesc: 'Последний официальный релиз в магазинах приложений.',
    forceUpdateTitle: 'Принудительное обновление (Force Update)',
    forceUpdateDesc: 'При включении пользователи со старыми версиями не смогут пользоваться приложением.',
    maintenanceTitle: 'Режим технических работ',
    maintenanceDesc: 'Переводит всё мобильное API в режим технического обслуживания.',
    maintenanceMessageTitle: 'Сообщение для пользователей',
    storeUrlsTitle: 'Ссылки на магазины приложений',
    androidUrl: 'Ссылка на Google Play',
    iosUrl: 'Ссылка на App Store',
    changelogTitle: 'Список изменений (Changelog)',
    saveConfigBtn: 'Сохранить и опубликовать на Edge',
    confirmModalTitle: 'Публикация конфигурации',
    confirmModalMessage: 'Вы уверены, что хотите обновить конфигурацию? Изменения вступят в силу для всех мобильных устройств.',
    saveSuccess: 'Конфигурация приложения обновлена и передана на Cloudflare Edge.',
    loadError: 'Не удалось загрузить конфигурацию приложения',
  },
  commands: {
    title: 'Очередь команд устройствам',
    description: 'Инструкции для мобильных клиентов: очистка кэша, запуск диагностики, сброс сессий',
    searchPlaceholder: 'Поиск по ID команды, ID устройства или типу...',
    allStatuses: 'Все статусы',
    tableId: 'ID команды',
    tableDevice: 'ID устройства',
    tableType: 'Тип',
    tableStatus: 'Статус',
    tableCreatedBy: 'Создатель',
    tableCreatedAt: 'Создано',
    tableExpiresAt: 'Истекает',
    tableActions: 'Действия',
    cancelCommandBtn: 'Отменить',
    inspectModalTitle: 'Сведения о команде',
    cancelConfirmTitle: 'Отменить команду',
    cancelConfirmMessage: 'Вы уверены, что хотите отменить эту команду? Она не будет выполнена устройством.',
    cancelSuccess: 'Команда успешно отменена',
    emptyTitle: 'Команды не найдены',
    emptyDesc: 'Нет доступных команд для отображения.',
    loadError: 'Не удалось загрузить команды',
  },
  snapshots: {
    title: 'Диагностические снимки поддержки',
    description: 'Зашифрованные временные архивы диагностики, загруженные с согласия пользователя',
    tableId: 'ID снимка',
    tableUserId: 'User ID',
    tableDeviceId: 'ID устройства',
    tableExpiresIn: 'Осталось времени',
    tableCreatedAt: 'Дата создания',
    tableActions: 'Действия',
    inspectBtn: 'Расшифровать и открыть',
    deleteBtn: 'Удалить',
    inspectModalTitle: 'Расшифровка диагностического снимка',
    inspectPrompt: 'Укажите причину доступа для журнала аудита:',
    reasonPlaceholder: 'например, расследование тикета #4982',
    submitInspect: 'Расшифровать и посмотреть',
    deleteModalTitle: 'Удалить снимок диагностики',
    deleteModalMessage: 'Вы уверены, что хотите безвозвратно удалить этот снимок из хранилища R2?',
    deleteSuccess: 'Диагностический снимок успешно удалён',
    emptyTitle: 'Диагностические снимки отсутствуют',
    emptyDesc: 'На данный момент нет доступных снимков диагностики.',
    loadError: 'Не удалось загрузить снимки',
  },
  audit: {
    title: 'Журнал безопасности и аудита',
    description: 'Неизменяемый журнал всех административных и авторизационных событий (OTP, вход, команды)',
    tabAuth: 'События авторизации и OTP',
    tabAll: 'Все административные действия',
    searchPlaceholder: 'Поиск по телефону, chat ID, admin ID, действию...',
    allActions: 'Все действия',
    tableTimestamp: 'Время',
    tableActor: 'Инициатор',
    tableAction: 'Действие',
    tableTarget: 'Целевой объект',
    tableDetails: 'Детали',
    emptyTitle: 'Записи аудита не найдены',
    emptyDesc: 'Нет записей, соответствующих критериям поиска.',
    inspectModalTitle: 'Детали события аудита',
    loadError: 'Не удалось загрузить журнал аудита',
  },
  system: {
    title: 'Состояние системы и инфраструктуры',
    description: 'Статус Cloudflare Edge API, базы данных D1, хранилищ KV и R2, очередей сообщений',
    refreshBtn: 'Обновить статус',
    allSystemsOperational: 'Все системы работают штатно',
    apiWorker: 'Cloudflare Workers Edge API',
    apiWorkerDesc: 'Глобальная бессерверная среда V8 для запросов /api/v1/*',
    d1Db: 'База данных Cloudflare D1',
    d1DbDesc: 'Кластер SQLite с репликацией в нескольких регионах',
    kvConfig: 'Пространство ключей Cloudflare KV',
    kvConfigDesc: 'Быстрое глобальное хранилище для настроек и флагов',
    r2Storage: 'Объектное хранилище Cloudflare R2',
    r2StorageDesc: 'S3-совместимое хранилище для зашифрованных снимков',
    queues: 'Очереди Cloudflare Queues',
    queuesDesc: 'Асинхронная доставка телеметрии и событий аудита',
    cronWorker: 'Автоматический Cron-воркер',
    cronWorkerDesc: 'Ежечасная очистка устаревших диагностических данных',
    latency: 'Задержка: {val}',
    loadError: 'Не удалось проверить состояние системы',
  },
  commandTypes: {
    export_snapshot: 'Экспорт диагностического снимка',
    clear_cache: 'Очистка локального кэша',
    refresh_config: 'Обновление настроек приложения',
    refresh_entitlements: 'Повторная проверка прав',
    logout: 'Выход из аккаунта (Logout)',
    invalidate_session: 'Принудительный сброс сессии',
    diagnostics: 'Запуск самодиагностики',
  },
};
